import { render, staticRenderFns } from "./CreateNoteControl.vue?vue&type=template&id=72018dc1&"
import script from "./CreateNoteControl.vue?vue&type=script&lang=js&"
export * from "./CreateNoteControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports